const firebase =  {
    apiKey: "AIzaSyAsXXJqb9o8cHdXzaryZUsXO0MtSlEtQ4k",
    authDomain: "test-60ae2.firebaseapp.com",
    databaseURL: "https://test-60ae2.firebaseio.com",
    projectId: "test-60ae2",
    storageBucket: "test-60ae2.appspot.com",
    messagingSenderId: "70192912043",
    appId: "1:70192912043:web:12b55a362ca68136dd89ee"
}
export default firebase;